import React, { useState } from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import { Container as ContainerBase } from "components/misc/Layouts";
import tw from "twin.macro";
import styled from "styled-components";
import illustration from "images/IMG_9355.JPG";
import logo from "images/BADtri_logo_black.svg";
import { Verify } from "api/openapi.ts";
import {
  Button,
  HStack,
  PinInput,
  PinInputField,
  useToast,
} from "@chakra-ui/react";
import { BeatLoader } from "react-spinners";
import { ReactComponent as VerifyIcon } from "feather-icons/dist/icons/shield.svg";

const ChakraButton = tw(Button)`tw-mt-8 tw-w-full`;
const ChakraHStack = tw(HStack)`tw-ml-auto tw-mr-auto tw-justify-center	`;
const Container = tw(
  ContainerBase,
)`tw-min-h-screen tw-bg-primary-900 tw-text-white tw-font-medium tw-flex tw-justify-center -tw-m-8`;
const Content = tw.div`tw-max-w-screen-xl tw-m-0 sm:tw-mx-20 sm:tw-my-16 tw-bg-white tw-text-gray-900 tw-shadow sm:tw-rounded-lg tw-flex tw-justify-center tw-flex-1`;
const MainContainer = tw.div`lg:tw-w-1/2 xl:tw-w-5/12 tw-p-6 sm:tw-p-12`;
const LogoLink = tw.a``;
const LogoImage = tw.img`tw-h-12 tw-mx-auto`;
const MainContent = tw.div`tw-mt-12 tw-flex tw-flex-col tw-items-center`;
const Heading = tw.h1`tw-text-2xl xl:tw-text-3xl tw-font-extrabold`;
const FormContainer = tw.div`tw-w-full tw-flex-1 tw-mt-16`;

const SocialButtonsContainer = tw.div`tw-flex tw-flex-col tw-items-center`;
const SocialButton = styled.a`
  ${tw`tw-w-full tw-max-w-xs tw-font-semibold tw-rounded-lg tw-py-3 tw-border tw-text-gray-900 tw-bg-gray-100 hocus:tw-bg-gray-200 hocus:tw-border-gray-400 tw-flex tw-items-center tw-justify-center tw-transition-all tw-duration-300 focus:tw-outline-none focus:tw-shadow-outline tw-text-sm tw-mt-5 first:tw-mt-0`}
  .iconContainer {
    ${tw`tw-bg-white tw-p-2 tw-rounded-full`}
  }
  .icon {
    ${tw`tw-w-4`}
  }
  .text {
    ${tw`tw-ml-4`}
  }
`;

const DividerTextContainer = tw.div`tw-my-12 tw-border-b tw-text-center tw-relative`;
const DividerText = tw.div`tw-leading-none tw-px-2 tw-inline-block tw-text-sm tw-text-gray-600 tw-tracking-wide tw-font-medium tw-bg-white tw-transform -tw-translate-y-1/2 tw-absolute tw-inset-x-0 tw-top-1/2 tw-bg-transparent`;

const Form = tw.form`tw-mx-auto tw-max-w-xs`;
const Input = tw.input`tw-w-full tw-px-8 tw-py-4 tw-rounded-lg tw-font-medium tw-bg-gray-100 tw-border tw-border-gray-200 tw-placeholder-gray-500 tw-text-sm focus:tw-outline-none focus:tw-border-gray-400 focus:tw-bg-white tw-mt-5 first:tw-mt-0`;
const SubmitButton = styled.button`
  ${tw`tw-mt-5 tw-tracking-wide tw-font-semibold tw-bg-primary-500 tw-text-gray-100 tw-w-full tw-py-4 tw-rounded-lg hover:tw-bg-primary-900 tw-transition-all tw-duration-300 tw-ease-in-out tw-flex tw-items-center tw-justify-center focus:tw-shadow-outline focus:tw-outline-none`}
  .icon {
    ${tw`tw-w-6 tw-h-6 -tw-ml-2`}
  }
  .text {
    ${tw`tw-ml-3`}
  }
`;
const IllustrationContainer = tw.div`sm:tw-rounded-r-lg tw-flex-1 tw-bg-purple-100 tw-text-center tw-overflow-hidden tw-hidden lg:tw-flex tw-justify-center`;
const IllustrationImage = styled.div`
  ${(props) => `background-image: url("${props.imageSrc}");`}
  ${tw`tw-w-full tw-bg-cover tw-bg-center tw-bg-no-repeat`}
`;

export default ({
  logoLinkUrl = "/",
  illustrationImageSrc = illustration,
  headingText = "Verify Your Email",
}) => {
  const toast = useToast();
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [verificationCode, setVerificationCode] = React.useState("");

  const verify = async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const membershipNumber = urlParams.get("membershipNumber");

    console.log(verificationCode);

    const signUpRequest = {
      membershipNumber: membershipNumber,
      confirmationCode: verificationCode,
    };
    setButtonDisabled(true);

    //TODO - check values are valid

    try {
      await Verify(signUpRequest);
      document.location.href = "/login?membershipNumber=" + membershipNumber;
    } catch (e) {
      console.log(e);
      setButtonDisabled(false);
      toast({
        title: "Hmm not quite try again...",
        status: "error",
        isClosable: true,
      });
    }
  };

  return (
    <AnimationRevealPage>
      <Container>
        <Content>
          <MainContainer>
            <LogoLink href={logoLinkUrl}>
              <LogoImage src={logo} />
            </LogoLink>
            <MainContent>
              <Heading>{headingText}</Heading>
              <FormContainer>
                <Form
                  onSubmit={(e) => {
                    e.preventDefault();
                  }}
                >
                  <ChakraHStack>
                    <PinInput
                      onChange={(e) => {
                        setVerificationCode(e);
                      }}
                    >
                      <PinInputField />
                      <PinInputField />
                      <PinInputField />
                      <PinInputField />
                      <PinInputField />
                      <PinInputField />
                    </PinInput>
                  </ChakraHStack>
                  <ChakraButton
                    isLoading={buttonDisabled}
                    spinner={<BeatLoader size={8} color="white" />}
                    colorScheme="red"
                    leftIcon={<VerifyIcon />}
                    onClick={verify}
                    size="lg"
                  >
                    Verify
                  </ChakraButton>
                </Form>
              </FormContainer>
            </MainContent>
          </MainContainer>
          <IllustrationContainer>
            <IllustrationImage imageSrc={illustrationImageSrc} />
          </IllustrationContainer>
        </Content>
      </Container>
    </AnimationRevealPage>
  );
};
